import { Text, VStack } from "native-base";
import React from "react";

import SimpleWebHeader from "@/components/molecules/SimpleWebHeader";
import Container from "@/components/organisms/Container";

import Form from "./components/Form";
import { LoginScreenProps } from "./types";

const LoginWeb = ({ isSubmiting, onSubmit, onRecoveryPass, onSingUp }: LoginScreenProps) => {
  return (
    <Container Header={<SimpleWebHeader />}>
      <VStack h="70vh" px="1/4" justifyContent="center">
        <Text fontSize="2xl" py="6">
          Entre ou Cadastre-se
        </Text>
        <Form
          isSubmiting={isSubmiting}
          onSubmit={onSubmit}
          onRecoveryPass={onRecoveryPass}
          onSingUp={onSingUp}
        />
      </VStack>
    </Container>
  );
};

export default LoginWeb;
